import { api } from '@/lib/axios';

export enum UserRole {
  ADMIN = 'ADMIN',
  USER = 'USER',
}

export interface User {
  id: string;
  email: string;
  name: string;
  role: UserRole;
  hasCalendar?: boolean;
  canSeeAllConversations?: boolean;
  userGroupId?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateUserDto {
  email: string;
  password: string;
  name: string;
  role: UserRole;
  hasCalendar?: boolean;
  canSeeAllConversations?: boolean;
  userGroupId?: string | null;
}

export interface UpdateUserDto {
  email?: string;
  password?: string;
  name?: string;
  role?: UserRole;
  hasCalendar?: boolean;
  canSeeAllConversations?: boolean;
  userGroupId?: string | null;
}

export const usersService = {
  async getAll(): Promise<User[]> {
    const { data } = await api.get('/users');
    return data;
  },

  async getById(id: string): Promise<User> {
    const { data } = await api.get(`/users/${id}`);
    return data;
  },

  async create(user: CreateUserDto): Promise<User> {
    const { data } = await api.post('/users', user);
    return data;
  },

  async update(id: string, user: UpdateUserDto): Promise<User> {
    const { data} = await api.patch(`/users/${id}`, user);
    return data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/users/${id}`);
  },

  // Métodos para gerenciar processos do funcionário
  async getUserProcesses(userId: string): Promise<any[]> {
    const { data } = await api.get(`/users/${userId}/processes`);
    return data;
  },

  async addProcess(userId: string, processId: string): Promise<void> {
    await api.post(`/users/${userId}/processes/${processId}`);
  },

  async removeProcess(userId: string, processId: string): Promise<void> {
    await api.delete(`/users/${userId}/processes/${processId}`);
  },

  // Métodos para gerenciar cargos do funcionário
  async getUserPositions(userId: string): Promise<any[]> {
    const { data } = await api.get(`/users/${userId}/positions`);
    return data;
  },

  async addPosition(userId: string, positionId: string): Promise<void> {
    await api.post(`/users/${userId}/positions/${positionId}`);
  },

  async removePosition(userId: string, positionId: string): Promise<void> {
    await api.delete(`/users/${userId}/positions/${positionId}`);
  },
};
